import { SERVER_API } from "../../Constant";
import axios from "axios";

export const UpdateCustomers = async (data: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(data));
    const response = await axios.post(
      `${SERVER_API}/Customers/update_customer_details.php`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Update customers failed:", error);
    return { error: "Update customers failed" };
  }
};
